import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { DropDownArrowIconSvg } from "../../assets/svg";

interface IOption {
  id?: number | string;
  value: string;
  label: string;
}

interface ICustomSelectProps {
  name?: string;
  clx?: string;
  value?: string | number | undefined;
  onChange: (option: IOption) => void;
  placeholder?: string;
  label?: string;
  options: IOption[];
  wantDefault?: boolean;
  disabled?: boolean;
}

const CustomSelect: React.FC<ICustomSelectProps> = (props) => {
  const { clx = "", value, onChange, placeholder, options, label, wantDefault, disabled = false } = props;

  const selectRef = useRef<HTMLDivElement>(null);
  const optionsArr = wantDefault ? [{ label: `Select ${label}`, value: '' }, ...options] : [...options];

  const [selectedOption, setSelectedOption] = useState<string | number | undefined>(value);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  const handleOptionSelect = (option: IOption) => {
    setIsDropdownOpen(false);
    onChange(option);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {label && (
        <label htmlFor="" className="pb-1 custom-label">
          {label}
        </label>
      )}
      <div ref={selectRef} className={`custom-select ${disabled ? 'disabled-styling' : ''} ${clx}`} onClick={() => !disabled ? setIsDropdownOpen(!isDropdownOpen) : () => {}}>
        <div className="selected-item">
          {(value || value === 0) ? (
            <span className="text-capitalize">{options.find((o) => o?.value === selectedOption)?.label?.toLowerCase()}</span>
          ) : (
            <span className="select-placeholder">{placeholder || `Select ${label}`}</span>
          )}
          <span className={`${isDropdownOpen ? "arrow-up" : "arrow-down"}`}>
            <DropDownArrowIconSvg fill={`${value ? '#212529' : '#aaa'}`} />
          </span>
        </div>
        <div className={` ${isDropdownOpen ? "options-container" : "hide"}`}>
          {!!options?.length ? (
            <ul className="options-list">
              {optionsArr?.map((option) => (
                <li key={option?.value} className="text-capitalize" style={{ whiteSpace: "nowrap" }}
                  onClick={() => handleOptionSelect(option)}>
                  {option?.label?.toLowerCase()}
                </li>
              ))}
            </ul>
          ) : (
            <ul className="options-list">
              <li className="d-flex justify-content-center">No Data</li>
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomSelect;
